<div *ngIf="insureData" class="wrap">
  <div class="content">
    <div class="section-1">
      <div class="text">
        <div class="title dmsans">Provide insurance for {{vars.fundraiser?.beneficiaryname?.info_1 | titlecase}} {{insuranceAgeTxt}}.</div>
        <!-- <div class="sub-title">Provide insurance cover for {{vars.fundraiser?.beneficiaryname?.info_1 | titlecase}}’s wife insurance cover. Lorem Ipsum Lorem Ipsum</div> -->
        <div class="sub-title" [ngClass]="{'expanded': viewMore}">The insurance cover of Daily Hospital cash will cover the hospitalization charges for the insured person for 30 days.</div>
        <!-- <div class="desc" [ngClass]="{'expanded': viewMore}">
          <ul>
            <li *ngFor="let item of desc">{{item.text}}</li>
          </ul>
        </div> -->
        <div class="read-more" (click)="viewMore=!viewMore">{{ viewMore ? 'Know Less' : 'Know More' }}<em class="material-icons" [ngClass]="{'expanded': viewMore}">expand_more</em> </div>
      </div>
      <div class="logo"><img src="/assets/images/insure-shield.png" alt="insure-shield"></div>
    </div>
    <div class="section-2">
      <div class="left">
        <div class="amount"><strong><app-currency [currency]="currency" />{{insureData?.left_amount}}</strong> remaining</div>
        <div class="bar"><div class="prog" [ngStyle]="{'width': progPerc+'%'}"></div></div>
      </div>
      <div class="right">
        <button *ngIf="selectedAmount === 0" class="add-btn" (click)="updateAmount('plus')" mat-ripple>Add</button>
        <div *ngIf="selectedAmount > 0" class="increment-btn">
          <button class="plus" (click)="updateAmount('minus')" mat-ripple>
            <em class="material-icons">remove</em>
          </button>
          <div class="amount"><app-currency [currency]="currency" />{{selectedAmount}}</div>
          <button class="minus" (click)="updateAmount('plus')" [ngClass]="{'max': selectedAmount === maxAmt}" [disabled]="selectedAmount === maxAmt" mat-ripple>
            <em class="material-icons">add</em>
          </button>
        </div>
      </div>
    </div>
  </div>
</div>